import BodyStyleFilter from '@/components/filters/BodyStyleFilter';
import BuyOnlineFilter from '@/components/filters/BuyOnlineFilter';
import DoorsFilter from '@/components/filters/DoorsFilter';
import DriveTypeFilter from '@/components/filters/DriveTypeFilter';
import ElectricMileRangeFilter from '@/components/filters/ElectricMileRangeFilter';
import EngineCodeFilter from '@/components/filters/EngineCodeFilter';
import EngineDisplacementFilter from '@/components/filters/EngineDisplacementFilter';
import ExteriorColorFilter from '@/components/filters/ExteriorColorFilter';
import FeaturesFilter from '@/components/filters/FeaturesFilter';
import FuelEconomyFilter from '@/components/filters/FuelEconomyFilter';
import FuelTypeFilter from '@/components/filters/FuelTypeFilter';
import InteriorColorFilter from '@/components/filters/InteriorColorFilter';
import ListingTypeFilter from '@/components/filters/ListingTypeFilter';
import LocationFilter from '@/components/filters/LocationFilter';
import MakeModelTrimFilter from '@/components/filters/MakeModelTrimFilter';
import MileageFilter from '@/components/filters/MileageFilter';
import PriceFilter from '@/components/filters/PriceFilter';
import PriceRatingFilter from '@/components/filters/PriceRatingFilter';
import SeatsFilter from '@/components/filters/SeatsFilter';
import SedanSizeFilter from '@/components/filters/SedanSizeFilter';
import SellerTypeFilter from '@/components/filters/SellerTypeFilter';
import SUVSizeFilter from '@/components/filters/SUVSizeFilter';
import TransmissionFilter from '@/components/filters/TransmissionFilter';
import TruckBedLengthFilter from '@/components/filters/TruckBedLengthFilter';
import TruckCabSizeFilter from '@/components/filters/TruckCabSizeFilter';
import VanSizeFilter from '@/components/filters/VanSizeFilter';
import VehicleExchangeFilter from '@/components/filters/VehicleExchangeFilter';
import VehicleHistoryTypeFilter from '@/components/filters/VehicleHistoryTypeFilter';
import VehicleTypeFilter from '@/components/filters/VehicleTypeFilter';
import VehicleUseTypeFilter from '@/components/filters/VehicleUseTypeFilter';
import YearFilter from '@/components/filters/YearFilter';

const filterComponentsMap = {
    BodyStyleFilter,
    BuyOnlineFilter,
    DoorsFilter,
    DriveTypeFilter,
    ElectricMileRangeFilter,
    EngineCodeFilter,
    EngineDisplacementFilter,
    ExteriorColorFilter,
    FeaturesFilter,
    FuelEconomyFilter,
    FuelTypeFilter,
    InteriorColorFilter,
    ListingTypeFilter,
    LocationFilter,
    MakeModelTrimFilter,
    MileageFilter,
    PriceFilter,
    PriceRatingFilter,
    SeatsFilter,
    SedanSizeFilter,
    SellerTypeFilter,
    SUVSizeFilter,
    TransmissionFilter,
    TruckBedLengthFilter,
    TruckCabSizeFilter,
    VanSizeFilter,
    VehicleExchangeFilter,
    VehicleHistoryTypeFilter,
    VehicleTypeFilter,
    VehicleUseTypeFilter,
    YearFilter,
};

export default filterComponentsMap;
